module.exports = __webpack_public_path__ + "static/media/4-sits_soffor.040449d7.jpg";